export const sortFields = ['name', 'countryCode'] as const;
